export const bearer = "Bearer ";
//export const CAP_KEY = "6LdZYrwUAAAAAKhe7551o1lm0VAtw6mI8hTe8RAj";
//export const KEY_PASS = "6LcqVUwfAAAAAGUUmoHs1e1Lr_rmm_lEqFWCreTl"; //balanceador local
export const KEY_PASS = "6Lckh0wfAAAAABYdGwAOEtA4lxVNj-cW2bmloe52"; //balanceador de pruebas, capacitacion y seguridad
export const CAP_KEY = "6LcePgAaAAAAAKxF7ZKlv85hO82BBvNenNYWifCT"; //balanceador de pruebas, capacitacion y seguridad
export const JSON_URL = "/jsonHelpers/jsonUrl.json";

export const linksRouter = {
  //URLS Privadas
  raizAdmin: "/admin",
  home: "/admin/inicio",
  datosAspirante: "/admin/CONCURSO_SIISPEN/detalleAspirante",
  formacionAcademica: "/admin/CONCURSO_SIISPEN/detalleAcademico",
  experiencia: "/admin/CONCURSO_SIISPEN/detalleAcademico",
  vacanteslogin: "/admin/CONCURSO_SIISPEN/Consulta_de_Vacantes",
  aprobada: "/admin/CONCURSO_SIISPEN/postulacionAprobada",
  declinada: "/admin/CONCURSO_SIISPEN/postulacionDeclinada",
  postulaciones: "/admin/CONCURSO_SIISPEN/postulaciones",
  expediente: "/admin/CONCURSO_SIISPEN/expediente",
  avisoPrivacidadINEAdmin: "/admin/aviso/privacidad/ine",
  avisoPrivacidadOPLEAdmin: "/admin/aviso/privacidad/ople",
  updateAdmin: "/admin/updatepaswd",
  //URLS Públicas
  login: "/login",
  raiz: "/",
  avisoPrivacidadINE: "/aviso/privacidad/ine",
  avisoPrivacidadOPLE: "/aviso/privacidad/ople",
  registro: "/registro",
  correo: "/correo",
  update: "/updatepaswd",
  FormExito: "/FormExito",
  cvacantes: "/Consulta_de_Vacantes",
  cuentaDesactivada: "/cuenta-sin_accesso",
  //otras
  forbbidenPage: "accesoRestringido",
  errorPage: "error",
};
